import { graphql } from '../../../../graphql/generated';

export const CREATE_PERIODIC_GROUP_MUTATION = graphql(`
  mutation CreatePeriodicGroup($input: PeriodicGroupCreateInput!) {
    createPeriodicGroup(input: $input) {
      id
    }
  }
`);
